import { convertFromBoolean, convertToBoolean, Form, FormInput, FormRadio } from 'metrix-common3';
import { FormattedMessage } from 'react-intl';

const Questionnaire = (props) => {
    const getValue = (answerValue) => {
        if (answerValue === undefined || answerValue === null) {
            return '-';
        }
        return `${answerValue}`;
    };

    return (
        <Form
            header={<FormattedMessage id='Profile_LiabilityExposures.title' />}
            label={<FormattedMessage id='Profile_LiabilityExposures.title' />}
            saveEvent={() => {
                props.doReducePolicyElement({ code: 'liabilityExposure.guid', value: props.policy.guid });
                props.doUpsertPolicy();
            }}
            cancelEvent={() => props.doGetPolicy()}
            allowEdit={props.allowEdit}
        >
            <FormRadio
                label={<FormattedMessage id='Profile_LiabilityExposures.multipleLocations' />}
                value={
                    props.policy?.liabilityExposure && {
                        code: convertFromBoolean(props.policy.liabilityExposure.hasMultipleLocations),
                    }
                }
                references={props.reference.references?.YesNo}
                referencesEvent={() => props.reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.hasMultipleLocations',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.weeksLocationRented' />}
                value={getValue(props?.policy?.liabilityExposure?.numberOfWeeksLocationRented)}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.numberOfWeeksLocationRented',
                        value: Number.parseInt(value, 10),
                    })
                }
                type='number'
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.roomsRented' />}
                value={getValue(props?.policy?.liabilityExposure?.numberOfRoomsRentedToOthers)}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.numberOfRoomsRentedToOthers',
                        value: Number.parseInt(value, 10),
                    })
                }
                type='number'
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.daycareChildren' />}
                value={getValue(props?.policy?.liabilityExposure?.daycareOperationNumberOfChildren)}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.daycareOperationNumberOfChildren',
                        value: Number.parseInt(value, 10),
                    })
                }
                type='number'
                allowEdit
            />
            <FormRadio
                label={<FormattedMessage id='Profile_LiabilityExposures.trampoline' />}
                value={
                    props.policy?.liabilityExposure && {
                        code: convertFromBoolean(props.policy.liabilityExposure.hasTrampoline),
                    }
                }
                references={props.reference.references?.YesNo}
                referencesEvent={() => props.reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.hasTrampoline',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormRadio
                label={<FormattedMessage id='Profile_LiabilityExposures.gardenTractor' />}
                value={
                    props.policy?.liabilityExposure && {
                        code: convertFromBoolean(props.policy.liabilityExposure.hasGardenTractor),
                    }
                }
                references={props.reference.references?.YesNo}
                referencesEvent={() => props.reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.hasGardenTractor',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormRadio
                label={<FormattedMessage id='Profile_LiabilityExposures.golfCart' />}
                value={
                    props.policy?.liabilityExposure && {
                        code: convertFromBoolean(props.policy.liabilityExposure.hasGolfCart),
                    }
                }
                references={props.reference.references?.YesNo}
                referencesEvent={() => props.reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.hasGolfCart',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.saddleAnimals' />}
                value={getValue(props?.policy?.liabilityExposure?.numberOfSaddleAnimals)}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.numberOfSaddleAnimals',
                        value: Number.parseInt(value, 10),
                    })
                }
                type='number'
                allowEdit
            />
            <FormRadio
                label={<FormattedMessage id='Profile_LiabilityExposures.recreationalVehicles' />}
                value={
                    props.policy?.liabilityExposure && {
                        code: convertFromBoolean(props.policy.liabilityExposure.hasUnlicensedRecreationalVehicles),
                    }
                }
                references={props.reference.references?.YesNo}
                referencesEvent={() => props.reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.hasUnlicensedRecreationalVehicles',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormRadio
                label={<FormattedMessage id='Profile_LiabilityExposures.renewableEnergy' />}
                value={
                    props.policy?.liabilityExposure && {
                        code: convertFromBoolean(
                            props.policy.liabilityExposure.hasRenewableEnergyInstallationOnPremises,
                        ),
                    }
                }
                references={props.reference.references?.YesNo}
                referencesEvent={() => props.reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.hasRenewableEnergyInstallationOnPremises',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormRadio
                label={<FormattedMessage id='Profile_LiabilityExposures.watercrafts' />}
                value={
                    props.policy?.liabilityExposure && {
                        code: convertFromBoolean(props.policy.liabilityExposure.hasWatercrafts),
                    }
                }
                references={props.reference.references?.YesNo}
                referencesEvent={() => props.reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.hasWatercrafts',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.fullTimeEmployees' />}
                value={getValue(props?.policy?.liabilityExposure?.numberOfFullTimeResidenceEmployees)}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.numberOfFullTimeResidenceEmployees',
                        value: Number.parseInt(value, 10),
                    })
                }
                type='number'
                allowEdit
            />
            <FormRadio
                label={<FormattedMessage id='Profile_LiabilityExposures.coOccupant' />}
                value={
                    props.policy?.liabilityExposure && {
                        code: convertFromBoolean(props.policy.liabilityExposure.hasCoOccupantRequiringCoverage),
                    }
                }
                references={props.reference.references?.YesNo}
                referencesEvent={() => props.reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.hasCoOccupantRequiringCoverage',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.coOccupantName' />}
                value={props.policy?.liabilityExposure?.coOccupantName}
                changeEvent={(value) =>
                    props.doReducePolicyElement({ code: 'liabilityExposure.coOccupantName', value })
                }
                allowEdit
            />
            <FormRadio
                label={<FormattedMessage id='Profile_LiabilityExposures.businessOperation' />}
                value={
                    props.policy?.liabilityExposure && {
                        code: convertFromBoolean(props.policy.liabilityExposure.hasBusinessOperation),
                    }
                }
                references={props.reference.references?.YesNo}
                referencesEvent={() => props.reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.hasBusinessOperation',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.describeBusinessOperation' />}
                value={props.policy?.liabilityExposure?.businessOperationDescription}
                changeEvent={(value) =>
                    props.doReducePolicyElement({ code: 'liabilityExposure.businessOperationDescription', value })
                }
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.numberOfDogs' />}
                value={getValue(props?.policy?.liabilityExposure?.numberOfDogs)}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.numberOfDogs',
                        value: Number.parseInt(value, 10),
                    })
                }
                type='number'
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.breedOfDogs' />}
                value={props.policy?.liabilityExposure?.breedsOfDogs}
                changeEvent={(value) => props.doReducePolicyElement({ code: 'liabilityExposure.breedsOfDogs', value })}
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.propertyArea' />}
                value={getValue(props?.policy?.liabilityExposure?.propertyArea)}
                changeEvent={(value) => {
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.propertyArea',
                        value: Number.parseInt(value, 10),
                    });
                }}
                type='number'
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.cannabisPlants' />}
                value={getValue(props?.policy?.liabilityExposure?.numberOfCannabisPlantsGrownOnPremises)}
                changeEvent={(value) =>
                    props.doReducePolicyElement({
                        code: 'liabilityExposure.numberOfCannabisPlantsGrownOnPremises',
                        value: Number.parseInt(value, 10),
                    })
                }
                type='number'
                allowEdit
            />
            <FormInput
                label={<FormattedMessage id='Profile_LiabilityExposures.otherExposures' />}
                value={props.policy?.liabilityExposure?.otherExposures}
                changeEvent={(value) =>
                    props.doReducePolicyElement({ code: 'liabilityExposure.otherExposures', value })
                }
                allowEdit
            />
        </Form>
    );
};

export default Questionnaire;
